import { render, staticRenderFns } from "./detailHistoricRecords.vue?vue&type=template&id=13d675c0&scoped=true&"
import script from "./detailHistoricRecords.vue?vue&type=script&lang=js&"
export * from "./detailHistoricRecords.vue?vue&type=script&lang=js&"
import style0 from "./detailHistoricRecords.vue?vue&type=style&index=0&id=13d675c0&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d675c0",
  null
  
)

export default component.exports